import { UserTypeEnum } from "@features/mySph/utils/types";

export const SHARE_TRACKING_OBJECT = {
  utm_source: "web_share",
  utm_medium: "referral",
  utm_campaign: "article",
};

export const PULSE_SHARE_TRACKING_OBJECT = {
  ...SHARE_TRACKING_OBJECT,
  utm_campaign: "pulse",
};

export const CHARTBEAT_USER_MAPPING: Record<UserTypeEnum, string> = {
  [UserTypeEnum.ANONYMOUS]: "anon",
  [UserTypeEnum.SUBSCRIBER]: "paid",
  [UserTypeEnum.REGISTERED]: "lgdin",
  [UserTypeEnum.GUEST]: "anon",
  [UserTypeEnum.IAP_SUBSCRIBER]: "lgdin",
};
